<template>
  <!--콘텐츠 영역-->

  <div id="sub_contents" class="sub_contents">
    <a href="#sub_area" id="top_btn"></a>
    <a @click="btnNewBoard" v-if="isAdmin" class="admin writing">뉴스룸 게시물 추가</a>
    <div class="News_list">
      <ul class="list">
        <li v-for="(obj, index) in list" :key="index">
          <a @click="btnDetail(obj)">
            <dl>
              <dd class="img">
                <img :src="obj.MAIN_IMG" />
              </dd>
              <dt>{{ obj.title }}</dt>
              <dd>{{ obj.createdAt | date }}</dd>
              <dd v-if="isAdmin && obj.bHide">비밀글</dd>
            </dl>
          </a>
        </li>
      </ul>
    </div>

    <router-view />
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import pm from "../common/protocolManager";
import eventBus from "../common/eventBus";

export default {
  data: () => ({
    message: "News.vue",
    list: [],
    isAdmin: false,
  }),
  methods: {
    btnDetail(obj) {
      console.log("btnDetail");
      this.$router.push(`/Public/NewsDetail/${obj._id}`);
    },
    reqList() {
      this.list = [];
      let url = `ferrumNewsList`;

      pm.get(url)
        .then((result) => {
          console.log("ferrumNewsList - ok");
          if (result.list.length) {
            for (let i = 0; i < result.list.length; i++) {
              if (result.list[i].files && result.list[i].files.bgImage.length) {
                result.list[i].MAIN_IMG =
                  pm.NAS_URL + result.list[i].files.bgImage[0].filename;
              }
            }
            this.list = result.list;
          }
        })
        .catch((error) => {
          console.log("error");
          alert("reqBoardList 에러");
        });
    },
    btnNewBoard() {
      console.log("btnNewBoard");
      this.$router.push(`/Public/News/NewsWritePopup`);
    },
    checkAdmin() {
      let url = "ferrum/isAdmin";
      pm.get(url)
        .then((result) => {
          console.log("checkAdmin - ok");
          if (result.role === 'admin') {
            this.isAdmin = true;
          } else {
            this.isAdmin = false;
          }
        })
        .catch((err) => {
          console.log("checkAdmin - err");
          this.isAdmin = false;
        });
    },

    admimRegister() {
      let url = "userRegister";
      let params = {
        userId: "ferrumAdmin",
        password: "ferrumInfra2020!@",
        roles: "admin",
      };

      pm.post(url, params)
        .then((result) => {
          console.log("admimRegister - ok");
        })
        .catch((err) => {
          console.log("admimRegister - err");
        });
    },
  },
  computed: {
    ...mapGetters(["getNewsList"]),
    GET_LIST() {
      return this.getNewsList;
    },
  },
  destroyed() {
    eventBus.$off("EVENT_CHANGE_BOARD_LIST");
  },
  created() {
    console.log("created - " + this.message);

    if (localStorage.authToken) {
      this.checkAdmin();
    }

    eventBus.$on("EVENT_CHANGE_BOARD_LIST", () => {
      console.log("EVENT_CHANGE_BOARD_LIST");
      this.reqList();
    });

    this.reqList();

    this.admimRegister();
  },
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/sub03/News.vue